import { CSSProp } from 'styled-components'
import { Shadows as RawShadows } from 'cio-design-library/design-tokens'

type ShadowVariations = {
  low: CSSProp
  mid: CSSProp
  high: CSSProp
}

type ShadowVariantName = 'light' | 'lightWithBorder' | 'dark' | 'template'

type ShadowsType = Record<ShadowVariantName, ShadowVariations>

/**
 * Shadows copied from our design system:
 * https://www.figma.com/file/ZY7L17bKSFLWnSf3Se84uzYn/Design-System?node-id=4055%3A3824
 *
 * @example
 * const Block = styled.div`
 *   ${Shadows.light.high};
 * `
 */

export const Shadows: ShadowsType = {
  light: {
    low: RawShadows.lightShadowLow,
    mid: RawShadows.lightShadowMid,
    high: RawShadows.lightShadowHigh,
  },
  lightWithBorder: {
    low: `box-shadow: ${RawShadows.lightWithBorderShadowLow}`,
    mid: `box-shadow: ${RawShadows.lightWithBorderShadowMid}`,
    high: `box-shadow: ${RawShadows.lightWithBorderShadowHigh}`,
  },
  dark: {
    low: RawShadows.darkShadowLow,
    mid: RawShadows.darkShadowMid,
    high: RawShadows.darkShadowHigh,
  },
  template: {
    low: RawShadows.templateShadowLow,
    mid: RawShadows.templateShadowMid,
    high: RawShadows.templateShadowHigh,
  },
}

export default Shadows
